import { render, staticRenderFns } from "./pl-message-container.vue?vue&type=template&id=43100227&"
import script from "./pl-message-container.vue?vue&type=script&lang=js&"
export * from "./pl-message-container.vue?vue&type=script&lang=js&"
import style0 from "./pl-message-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports